/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PalAuthSubmissionLeadWaitlistDetails } from './PalAuthSubmissionLeadWaitlistDetails';
import {
    PalAuthSubmissionLeadWaitlistDetailsFromJSON,
    PalAuthSubmissionLeadWaitlistDetailsFromJSONTyped,
    PalAuthSubmissionLeadWaitlistDetailsToJSON,
} from './PalAuthSubmissionLeadWaitlistDetails';
import type { PalAuthSubmissionLeadWaitlistUpdatesInner } from './PalAuthSubmissionLeadWaitlistUpdatesInner';
import {
    PalAuthSubmissionLeadWaitlistUpdatesInnerFromJSON,
    PalAuthSubmissionLeadWaitlistUpdatesInnerFromJSONTyped,
    PalAuthSubmissionLeadWaitlistUpdatesInnerToJSON,
} from './PalAuthSubmissionLeadWaitlistUpdatesInner';
import type { PalAuthSubmissionStatusUpdatedByUser } from './PalAuthSubmissionStatusUpdatedByUser';
import {
    PalAuthSubmissionStatusUpdatedByUserFromJSON,
    PalAuthSubmissionStatusUpdatedByUserFromJSONTyped,
    PalAuthSubmissionStatusUpdatedByUserToJSON,
} from './PalAuthSubmissionStatusUpdatedByUser';

/**
 * 
 * @export
 * @interface PalAuthSubmissionLeadWaitlist
 */
export interface PalAuthSubmissionLeadWaitlist {
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionLeadWaitlist
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionLeadWaitlist
     */
    lead_id?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionLeadWaitlist
     */
    status?: PalAuthSubmissionLeadWaitlistStatusEnum;
    /**
     * 
     * @type {PalAuthSubmissionLeadWaitlistDetails}
     * @memberof PalAuthSubmissionLeadWaitlist
     */
    details?: PalAuthSubmissionLeadWaitlistDetails;
    /**
     * 
     * @type {number}
     * @memberof PalAuthSubmissionLeadWaitlist
     */
    rank?: number;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionLeadWaitlist
     */
    created_at?: string;
    /**
     * 
     * @type {PalAuthSubmissionStatusUpdatedByUser}
     * @memberof PalAuthSubmissionLeadWaitlist
     */
    status_set_by_user?: PalAuthSubmissionStatusUpdatedByUser;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionLeadWaitlist
     */
    receipt_id?: string;
    /**
     * 
     * @type {Array<PalAuthSubmissionLeadWaitlistUpdatesInner>}
     * @memberof PalAuthSubmissionLeadWaitlist
     */
    updates?: Array<PalAuthSubmissionLeadWaitlistUpdatesInner>;
}


/**
 * @export
 */
export const PalAuthSubmissionLeadWaitlistStatusEnum = {
    Waitlisted: 'Waitlisted',
    Cleared: 'Cleared',
    Cancelled: 'Cancelled'
} as const;
export type PalAuthSubmissionLeadWaitlistStatusEnum = typeof PalAuthSubmissionLeadWaitlistStatusEnum[keyof typeof PalAuthSubmissionLeadWaitlistStatusEnum];


/**
 * Check if a given object implements the PalAuthSubmissionLeadWaitlist interface.
 */
export function instanceOfPalAuthSubmissionLeadWaitlist(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PalAuthSubmissionLeadWaitlistFromJSON(json: any): PalAuthSubmissionLeadWaitlist {
    return PalAuthSubmissionLeadWaitlistFromJSONTyped(json, false);
}

export function PalAuthSubmissionLeadWaitlistFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthSubmissionLeadWaitlist {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'lead_id': !exists(json, 'lead_id') ? undefined : json['lead_id'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'details': !exists(json, 'details') ? undefined : PalAuthSubmissionLeadWaitlistDetailsFromJSON(json['details']),
        'rank': !exists(json, 'rank') ? undefined : json['rank'],
        'created_at': !exists(json, 'created_at') ? undefined : json['created_at'],
        'status_set_by_user': !exists(json, 'status_set_by_user') ? undefined : PalAuthSubmissionStatusUpdatedByUserFromJSON(json['status_set_by_user']),
        'receipt_id': !exists(json, 'receipt_id') ? undefined : json['receipt_id'],
        'updates': !exists(json, 'updates') ? undefined : ((json['updates'] as Array<any>).map(PalAuthSubmissionLeadWaitlistUpdatesInnerFromJSON)),
    };
}

export function PalAuthSubmissionLeadWaitlistToJSON(value?: PalAuthSubmissionLeadWaitlist | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'lead_id': value.lead_id,
        'status': value.status,
        'details': PalAuthSubmissionLeadWaitlistDetailsToJSON(value.details),
        'rank': value.rank,
        'created_at': value.created_at,
        'status_set_by_user': PalAuthSubmissionStatusUpdatedByUserToJSON(value.status_set_by_user),
        'receipt_id': value.receipt_id,
        'updates': value.updates === undefined ? undefined : ((value.updates as Array<any>).map(PalAuthSubmissionLeadWaitlistUpdatesInnerToJSON)),
    };
}

